import classNames from 'classnames';
import React__default from 'react';
import { s as styleInject } from '../style-inject.es-746bb8ed.js';

var css_248z = "[dir] .xlM3z{border-bottom:1px solid var(--ricos-settings-dividers-color,rgba(0,0,0,.314))}[dir] .xlM3z.GUC23{margin-top:24px}[dir] .xlM3z.mJgoy{margin-bottom:24px}";
var styles = {"settingsSeparator":"xlM3z","settingsSeparator_top":"GUC23","settingsSeparator_bottom":"mJgoy"};
styleInject(css_248z);

const SettingsSeparator = ({ top = false, bottom = false }) => {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames(styles.settingsSeparator, {
        [styles.settingsSeparator_top]: top,
        [styles.settingsSeparator_bottom]: bottom
      })
    }
  );
};

export { SettingsSeparator as default };
//# sourceMappingURL=SettingsSeparator.js.map
